<template>
  <div>
    <!-- «Импорт»: импорт канала через сервис epgimport (2026-10-26).
         Python-импорт ядра из панели больше не вызывается; его эндпоинт
         в ядре остаётся для отката. -->
    <b-button
      :disabled="!hasUpdatePermissions || importRunning"
      :variant="'success'"
      class="mb-1 float-right"
      @click="importProgramService()"
      >{{ $t("message.Импорт_програмы") }}</b-button
    >
    <b-button
      v-if="imp.expired"
      size="sm"
      class="mb-1 mr-1 mt-1 float-right"
      @click="pollImport(imp.runId)"
      >{{ $t("message.Импорт_EPG_сервис_проверить_снова") }}</b-button
    >
    <!-- Отмена идущего запуска сервиса (этап 3). -->
    <b-button
      v-if="hasUpdatePermissions && imp.runId"
      size="sm"
      :variant="'outline-danger'"
      class="mb-1 mr-1 mt-1 float-right"
      @click="cancelImport()"
      >{{ $t("message.Импорт_EPG_сервис_остановить") }}</b-button
    >
    <div v-if="imp.line" class="clearfix mb-2 text-muted text-right">
      {{ imp.line }}
    </div>

    <date-picker
      v-model="curDate"
      class="float-left mb-3"
      :lang="lang"
      :format="'DD.MM.YYYY'"
      :clearable="false"
    ></date-picker>

    <b-table id="program-table" :items="programs" :fields="fields">
      <template slot="time" slot-scope="data"
        >{{ data.item.starts_at | moment("HH:mm") }}&nbsp;-&nbsp;{{
          data.item.ends_at | moment("HH:mm")
        }}</template
      >
      <template slot="min_age" slot-scope="data"
        >{{ data.item.min_age }}+</template
      >
    </b-table>
  </div>
</template>
<script>
import Vue from "vue";
import DatePicker from "vue2-datepicker";

Vue.use(require("vue-moment"));

import {
  cancelRun,
  isFinished,
  isDryRun,
  runTitle,
  stateLine,
  channelLine
} from "./epgImportService";

const POLL_MS = 5000; // опрос запуска
const POLL_UNAVAILABLE_MS = 10000; // опрос, пока сервис не отвечает
const POLL_LIMIT_MS = 10 * 60 * 1000; // предел автоматического опроса

export default {
  name: "ProgramForm",
  props: ["model"],
  components: { DatePicker },

  data() {
    return {
      programs: [],
      fields: [
        { key: "time", sortable: false },
        { key: "name", sortable: false },
        { key: "description", sortable: false },
        { key: "min_age", sortable: false }
      ],
      curDate: "",
      lang: "ru",
      // Запуск сервиса epgimport для этого канала (кнопка «Импорт»).
      imp: { run: null, line: "", runId: null, deadline: 0, expired: false, timer: null, seq: 0, stopped: false }
    };
  },
  computed: {
    importRunning: function() {
      return !!this.imp.runId && !this.imp.expired;
    },
    hasUpdatePermissions: function() {
      return !!this.$storage
        .get("current_user")
        .permissions.filter(value => value == "channels:fully_manage").length;
    }
  },
  created: function() {
    // Передачи за дату загружает наблюдатель curDate (updateProgram).
    // Прежний вызов GET /channels/<id>/programs без даты удалён: такого
    // маршрута в ядре нет (404); при окне программы lazy форма создаётся
    // уже с каналом, и вызов стал выполняться.
    let d = new Date();
    this.curDate = d.getTime();
  },
  mounted: function() {
    this.loadLastImport();
  },
  beforeDestroy: function() {
    this.imp.stopped = true;
    clearTimeout(this.imp.timer);
  },
  watch: {
    model: function() {
      this.updateProgram();
      clearTimeout(this.imp.timer);
      this.imp.seq++; // прежний опрос другого канала больше не продолжается
      this.imp.runId = null;
      this.imp.expired = false;
      this.imp.line = "";
      this.loadLastImport();
    },
    curDate: function() {
      this.updateProgram();
    }
  },

  updated: function() {
    // console.log(this.model);
    // if(this.model.id) {
    //     let promise = this.$noname.getChild('channels', this.model.id, 'programs/2019-01-01', {});
    //
    //     return promise.then((data) => {
    //         this.programs = data.data.items
    //     }).catch(this.$noname.HandleError)
    // }
  },
  methods: {
    updateProgram: function() {
      if (this.model.id) {
        let promise = this.$noname.getChild(
          "channels",
          this.model.id,
          "programs/" + this.$moment(this.curDate).format("DDMMYY"),
          {}
        );

        return promise
          .then(data => {
            this.programs = data.data.items;
          })
          .catch(this.$noname.HandleError);
      }
    },
    impT(key) {
      return this.$i18n.t("message." + key);
    },
    // Строка состояния: «Последняя проверка 10:17 — успешно: ok: вставлено бы 86, …».
    importLine(run) {
      const line = stateLine(run, this.impT);
      const ch = isFinished(run) ? channelLine(run, this.impT) : "";
      return ch ? line + ": " + ch : line;
    },
    // При открытии формы — последний запуск, в охват которого входит канал.
    loadLastImport: function() {
      if (!this.model.id || !this.hasUpdatePermissions) {
        return;
      }
      const id = this.model.id;
      return this.$noname
        .getChild("channels", id, "programs_import_service/last")
        .then(response => {
          if (this.imp.stopped || this.model.id !== id) {
            return;
          }
          const run = response.data || {};
          if (!run.run_id) {
            return; // 204 — по каналу запусков не было
          }
          this.imp.run = run;
          this.imp.line = this.importLine(run);
          if (!isFinished(run)) {
            this.pollImport(run.run_id);
          }
        })
        .catch(error => {
          const status = error.response && error.response.status;
          if (status === 503) {
            this.imp.line = this.impT("Сервис_импорта_недоступен");
          }
        });
    },
    // Кнопка «Остановить»: запуск, за которым следит форма; после ответа —
    // опрос до итога cancelled, список передач перечитывается.
    cancelImport: function() {
      const runId = this.imp.runId;
      if (!runId) {
        return;
      }
      const run = this.imp.run && this.imp.run.run_id === runId ? this.imp.run : { run_id: runId, channel_ids: [] };
      return cancelRun(this, run, this.impT, () => this.pollImport(runId));
    },
    // Кнопка «Импорт»: канал через сервис epgimport, сохранённый архив
    // источника; запись или проверка — по ключу ядра epg_import_dry_run.
    importProgramService: function() {
      if (!this.model.id) {
        return;
      }
      const t = this.impT;

      return this.$noname
        .postChild("channels", this.model.id, "programs_import_service", {})
        .then(response => {
          // Вид запуска — из ответа сервиса: «проверка» или «импорт» канала.
          const run = { kind: response.data.kind, channel_ids: [this.model.id] };
          Vue.notify({ group: "notify", text: t("Импорт_EPG_сервис_запущен") + ": " + runTitle(run, t), type: "success" });
          this.pollImport(response.data.run_id);
        })
        .catch(error => {
          const status = error.response && error.response.status;
          const data = (error.response && error.response.data) || {};
          if (status === 409) {
            // Сервис выполняет один запуск за раз — следим за идущим; после
            // его окончания список передач перечитывается.
            Vue.notify({
              group: "notify",
              text: t("Импорт_EPG_сервис_уже_идёт") + ": " + runTitle(data, t),
              type: "warn"
            });
            this.pollImport(data.active_run_id);
          } else if (status === 404) {
            Vue.notify({ group: "notify", text: data.msg || t("Импорт_EPG_сервис_состояние_недоступно"), type: "error" });
          } else if (status === 503) {
            Vue.notify({ group: "notify", text: t("Сервис_импорта_недоступен"), type: "error" });
          } else if (status === 403) {
            Vue.notify({ group: "notify", text: t("Нет_права_на_импорт"), type: "error" });
          } else {
            this.$noname.HandleError(error);
          }
        });
    },
    // Опрос запуска раз в 5 с до 10 мин; дальше — «импорт продолжается»
    // и кнопка «Проверить снова» с тем же run_id. По окончании любого
    // запуска, за которым следит форма, список передач перечитывается.
    // Новый вызов заменяет прежний опрос: ответ на запрос прежнего, ещё не
    // пришедший к этому моменту, отбрасывается (seq) — иначе опросов два.
    pollImport: function(runId) {
      clearTimeout(this.imp.timer);
      const seq = ++this.imp.seq;
      this.imp.runId = runId;
      this.imp.expired = false;
      this.imp.deadline = Date.now() + POLL_LIMIT_MS;
      const id = this.model.id;
      const t = this.impT;

      const next = ms => {
        if (this.imp.stopped || this.model.id !== id || seq !== this.imp.seq) {
          return;
        }
        if (Date.now() > this.imp.deadline) {
          this.imp.expired = true;
          this.imp.line = t("Импорт_EPG_сервис_продолжается");
          return;
        }
        this.imp.timer = setTimeout(poll, ms);
      };
      const poll = () => {
        this.$noname
          .getChild("channels", id, "programs_import_service/" + runId)
          .then(response => {
            if (seq !== this.imp.seq) {
              return;
            }
            const run = response.data || {};
            this.imp.run = run;
            this.imp.line = this.importLine(run);
            if (!isFinished(run)) {
              next(POLL_MS);
              return;
            }
            this.imp.runId = null;
            this.notifyImport(run);
            this.updateProgram();
          })
          .catch(error => {
            if (seq !== this.imp.seq) {
              return;
            }
            const status = error.response && error.response.status;
            if (status === 503) {
              this.imp.line = t("Импорт_EPG_сервис_не_отвечает");
              next(POLL_UNAVAILABLE_MS);
              return;
            }
            this.imp.runId = null;
            if (status === 404) {
              this.imp.line = t("Импорт_EPG_сервис_состояние_недоступно");
            } else {
              this.$noname.HandleError(error);
            }
          });
      };
      poll();
    },
    notifyImport: function(run) {
      const t = this.impT;
      const lines = [
        t(isDryRun(run) ? "Импорт_EPG_сервис_проверка_завершена" : "Импорт_EPG_сервис_завершён")
      ];
      const ch = channelLine(run, t);
      if (ch) {
        lines.push(ch);
      }
      if (run.error) {
        lines.push(run.error);
      }
      const r = (run.summary && run.summary.channels && run.summary.channels[0]) || {};
      Vue.notify({
        group: "notify",
        text: lines.join("<br>"),
        type: run.status === "succeeded" && r.status === "ok" ? "success" : "warn",
        // Висит, пока не щёлкнуть по ней (как итог в списке каналов).
        duration: -1
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/ProgramForm.vue